<template>
  <button
    @click="selectTab"
    class="flex items-center font-body font-normal text-sm p-0 pb-2 bg-transparent border-0 border-b-1 border-border border-solid"
    :class="{
      '!border-signableBrandColours-signableBlue border-b-3 pb-0': selected,
      'cursor-pointer hover:bg-signableBrandColours-lightGrey': !selected,
    }"
    data-test="tab"
  >
    <span
      class="relative flex items-center py-md px-base sm:px-md -mb-3 text-signableBrandColours-black after:absolute after:h-none after:block after:select-none after:pointer-none after:content-[attr(data-title)] after:font-bold after:invisible"
      :class="{
        'font-bold': selected,
        '!pr-0': dismissible,
      }"
      :data-title="title"
      data-test="title"
    >
      <ExclamationIcon
        v-if="hasError"
        aria-hidden="true"
        class="text-white bg-warning2 w-md mr-xs rounded-full"
      />
      <span>
        {{ title }}
      </span>
    </span>
    <button
      v-if="dismissible"
      @click="dismissTab"
      class="flex items-center p-sm ml-3 mr-xs -mb-3 border-none cursor-pointer
      bg-transparent text-signableBrandColours-darkGrey hover:text-signableBrandColours-black active:text-signableBrandColours-midGrey"
      :aria-label="$t('library.tabs.tabItem.dismissAria')"
      data-test="dismiss-btn"
    >
      <XMarkIcon class="h-twelve w-twelve" />
    </button>
  </button>
</template>

<script>
import { defineComponent } from 'vue';

import { ExclamationIcon, XMarkIcon } from '@/components/library/icons';

export default defineComponent({
  components: { ExclamationIcon, XMarkIcon },
  props: {
    title: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
    dismissible: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    function dismissTab(e) {
      e.stopPropagation();
      emit('dismissed', props.id);
    }

    function selectTab() {
      if (!props.selected) {
        emit('selected', props.id);
      }
    }

    return {
      dismissTab,
      selectTab,
    };
  },
});
</script>
